import React, { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import Api from "../../services/ApiService";


/**
 * Autocomplete field for city
 * -------------------------------
 * fetches data from public api of all available cities with provided
 * country code (at,de, ...) and zip code then uses this data for 
 * auto complition.
 * 
 * @param {string} zip data zip
 * @param {string} country Odoo numeric country codes
 * @param {string} city value of field in data
 * @param {setter} setCity setter for field city in data
 * @param {setter} outsidePlaces setter for outside array used for validation
 * @param {boolean} isError display if error was on field
 * 
 * @returns html autocomplete field
 */
const CityAutocomplete = ({ zip, country, city, setCity, outsidePlaces, isError, disabled}) => {

    const PUBLIC_API = new Api();
    const [places, setPlaces] = useState([]);

    // * when value of zip changes 
    useEffect(() => {
        if (zip.length > 3) {
            fetchCityApi();
        } else {
            setPlaces([]);
        }
    }, [zip])


    // * fetch cities from api
    const fetchCityApi = () => {
        // call to api
        
        PUBLIC_API.fetchCities(country, zip)
            .then(res => {
                var tempList = []; // temp array for collecting items

                // if result has data
                if (res.data.length > 0) {
                    // loop through each element
                    res.data.forEach(place => {
                        // if place name includes "," split it and text 0 element
                        if (place.name.includes(",")) place.name = place.name.split(",")[0];
                        // if not already in list append
                        if (!tempList.includes(place.name)) tempList.push(place.name);
                    });
                    setPlaces(tempList);
                    outsidePlaces(tempList);
                
                // if result is empty
                } else {
                    setPlaces([]);
                    outsidePlaces([]);
                }
            });
    }

    return (
        <Typeahead
            id="ort-ac"
            style={{ height: "56px" }}
            placeholder="Ort"
            selected={city ? [city] : []}
            onInputChange={(text, e) => setCity(text)}
            onChange={e => setCity(e[0])}
            options={places}
            isValid={places.includes(city)}
            isInvalid={isError}
            disabled={disabled}
        />
    )
}
export default CityAutocomplete;